import { Cell, Table, TableBody, TableCell, TableHead, TableHeader, TableRow, Text, useStyles } from 'bold-ui'
import { Box } from 'components/Box'
import { CheckboxField } from 'components/form'

import { AnoSelectField } from '../citopatologico/AnoSelectField'
import { anamneseCirurgiaTableOptions, MamografiaPerguntaField } from './model-mamografia'

export function MamografiaAnamneseCirurgiaTable() {
  const { classes } = useStyles(createStyles)

  return (
    <Cell size={12}>
      <Box>
        <CheckboxField name={MamografiaPerguntaField.fezCirurgiaMama} label='Fez cirurgia na mama' />
      </Box>
      <Table style={classes.table}>
        <TableHead>
          <TableRow>
            <TableHeader style={classes.header}>Opções de cirurgia</TableHeader>
            <TableHeader style={classes.header}>Mama direita</TableHeader>
            <TableHeader style={classes.header}>Mama esquerda</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {anamneseCirurgiaTableOptions.map(({ label, valueDireita, valueEsquerda }) => (
            <TableRow key={label}>
              <TableCell style={classes.cell}>
                <Text>{label}</Text>
              </TableCell>
              <TableCell style={classes.cell}>
                <AnoSelectField placeholder='Ano da cirurgia' name={valueEsquerda} />
              </TableCell>
              <TableCell style={classes.cell}>
                <AnoSelectField placeholder='Ano da cirurgia' name={valueDireita} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Cell>
  )
}

const createStyles = () => ({
  table: {
    padding: '1rem',
    borderTop: 'none',
  },
  header: {
    width: '33.33%',
  },
  cell: {
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
  },
})
